import NewSupplier from "../../../../components/@groups/suppliers/NewSupplier";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SupplierGroupNewPage() {

    return (
        <NewSupplier 
            routeType={routeTypes.admin}
        />
    )
}       